module.exports = __webpack_public_path__ + "static/img/地产.15e2ba82.png";